import ArticleContent from './article-content';

export default ArticleContent;
